import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ContactListItem from 'components/Contacts/ContactListItem';
import FavoritesSearchCont from 'containers/FavoritesSearch/FavoritesSearchContainer';
import Spinner from 'components/MainSpinner/MainSpinner';
import { listItemSpinnerConfig } from 'constants/Spinner';
import { selectContact } from 'utils/contact-utils';
import classes from './Favorites.module.scss';

class Favorites extends React.PureComponent {
  componentWillUnmount() {
    this.props.handleToggleAddFavorites(false);
  }

  handleSelectContact = (contact) => {
    selectContact(contact, this.props.history.push);
  };

  renderSpinner = () => (
    <div>
      <Spinner
        config={listItemSpinnerConfig}
      />
    </div>
  );

  render() {
    return (
      <div className={classes.favoritesContainer}>
        <div className={classes.favoritesLabelContainer}>
          <div className={classes.favoritesLabel}>
            <FormattedMessage
              id="components.activityFeed.favoritesLabel"
              description="Favorites label"
              defaultMessage="Favorites"
            />
          </div>
          <button className={classes.editLink} onClick={this.props.handleToggleAddFavorites} data-testid="favorite-edit">
            {this.props.isAddVisible ?
              <FormattedMessage
                id="components.activityFeed.doneLabel"
                defaultMessage="Done"
              />
              :
              <FormattedMessage
                id="components.activityFeed.addLabel"
                defaultMessage="Add"
              />
            }
          </button>
        </div>
        <hr />
        {this.props.isAddVisible ?
          <div>
            <FavoritesSearchCont
              numFavorites={this.props.numFavorites}
            />
          </div>
          :
          null
        }
        {this.props.isLoaded ?
          <div className={classes.favoritesList}>
            {this.props.favorites.length ?
              <div className={classes.contactsList}>
                {this.props.favorites.map(favorite =>
                  <ContactListItem
                    className={classes.contactListItem}
                    classNameContactName={classes.contactName}
                    contact={favorite}
                    dataTestTag='favorite-contact'
                    handleAudioCall={this.props.handleAudioCall}
                    handleChat={this.props.handleChat}
                    handleRemove={this.props.handleRemoveAsFavorite}
                    handleSelectContact={this.handleSelectContact}
                    handleVideoCall={this.props.handleVideoCall}
                    hideContacts={this.props.hideContacts}
                    hideMeetings={this.props.hideMeetings}
                    hideRooms={this.props.hideRooms}
                    hideParticipantCount
                    hideStar
                    shortList
                    isChatEnabled={this.props.isChatEnabled}
                    key={favorite.id}
                    nameFontSize={'12px'}
                  />
                )}
              </div>
              :
              <div className={classes.emptyFavoritesList}>
                <FormattedMessage
                  id="components.activityFeed.favoritesEmpty"
                  description="Favorites Empty Message"
                  defaultMessage="When you add favorites, they will appear here."
                />
              </div>
            }
          </div>
          :
          this.renderSpinner()
        }
        <div className={classes.bottomFade} />
      </div>);
  }
}

Favorites.propTypes = {
  favorites: PT.array.isRequired,
  handleAudioCall: PT.func.isRequired,
  handleChat: PT.func.isRequired,
  handleRemoveAsFavorite: PT.func.isRequired,
  handleToggleAddFavorites: PT.func.isRequired,
  handleVideoCall: PT.func.isRequired,
  hideContacts: PT.bool,
  hideMeetings: PT.bool,
  hideRooms: PT.bool,
  isAddVisible: PT.bool.isRequired,
  isChatEnabled: PT.bool,
  isLoaded: PT.bool,
  numFavorites: PT.number
};

export default Favorites;
